import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreviewComponent } from './preview.component';
import { PreviewScorecardComponent } from './components/preview-scorecard/preview-scorecard.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { PreviewRewardComponent } from './components/preview-reward/preview-reward.component';
import { RouterModule } from '@angular/router';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { LottosListItemModule } from '@fgb/portal-component-library/src/lib/loyalty/lottos/lottos-list-item';
import { AuctionPanelModule } from '@fgb/portal-component-library/src/lib/loyalty/auctions/auction-panel';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { ScorecardModule } from '@fgb/portal-component-library/src/lib/loyalty/scorecards';
import { MarketplaceListItemModule } from '@fgb/portal-component-library/src/lib/loyalty/marketplace/marketplace-list-item';

const components = [PreviewComponent, PreviewScorecardComponent, PreviewRewardComponent];
@NgModule({
  declarations: [...components],
  imports: [
    CommonModule,
    ScorecardModule,
    NgbModule,
    CarouselModule,
    PipesModule,
    NgbModule,
    RouterModule,
    DirectivesModule,
    FGBSharedModule,
    AuctionPanelModule,
    MarketplaceListItemModule,
    LottosListItemModule,
  ],
  exports: [...components],
})
export class PreviewModule {}
